import type { ListingWireInstruction } from '@adc/sdk/types'

/**
 * CRITICAL: Do not modify account information without approval.
 *
 * These are the Illinois (IL) foreclosure deposit payment details.
 * Wire account is specific to IL deposits and differs from the REO
 * account used in resi-document-generation EFTInstructions.
 */

/**
 * Wire details for the wire transfer tab.
 * Overlapping fields reuse the SDK ListingWireInstruction shape so no
 * parallel wiring data structure is introduced. The extra fields below
 * (flat bank address + beneficiary data) come from the IL deposit design
 * and should be added to the schema type if this data ever moves to the API.
 */
export interface WireDetails
  extends Pick<
    ListingWireInstruction,
    'bank_name' | 'routing_number' | 'account_number'
  > {
  bank_address: string
  beneficiary_account_name: string
  beneficiary_address: string
}

export interface CheckDetails {
  make_payable_to: string
  /** Lines: office name + address */
  drop_off_at: string[]
  /** Lines: schedule + closure note */
  hours: string[]
}

export const IL_DEPOSIT_WIRE_DETAILS: WireDetails = {
  bank_name: 'Wells Fargo Bank, N.A.',
  bank_address: '420 Montgomery St., San Francisco, CA 94104',
  routing_number: '121000248',
  account_number: '4943703629',
  beneficiary_account_name: 'Auction.com, LLC - IL Deposit',
  beneficiary_address: '1 Mauchly, Irvine, CA 92618',
}

export const IL_DEPOSIT_CHECK_DETAILS: CheckDetails = {
  make_payable_to: 'Auction.com, LLC',
  drop_off_at: [
    'Auction.com PSO Office',
    '100 N LaSalle Street, Suite 1400 Chicago, IL 60602',
  ],
  hours: [
    'Mon-Fri: 9AM-5PM CT',
    'Our office is closed on weekends and all major holidays',
  ],
}

export const IL_DEPOSIT_CONTACT_EMAIL = 'IL_PSO_CustomerService@auction.com'
export const IL_DEPOSIT_CONTACT_PHONE = '(872)-225-4985'
